// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__stUUY","file":"styles_file__ENA46"};